import axios from 'axios'
import * as Cookies from 'tiny-cookie'

export const security = {
  namespaced: true,
  state: {
    Token: null,
    UserId: -1,
    Username: '',
    Rules: [],
    Provinces: [],
    Clubs: [],
    Message: ''
  },
  getters: {
    Token: state => state.Token,
    UserId: state => state.UserId,
    Username: state => state.Username,
    Message: state => state.Message,
    HasPermission: state => (permissiontag) => {
      return false || (permissiontag !== undefined && state.Rules != null && state.UserId > 0 && state.Rules.includes(permissiontag))
    },
    HasProvincePermission: state => (provinceid, permissiontag) => {
      return false || (permissiontag !== undefined && state.Provinces[provinceid] && state.UserId > 0 && state.Provinces[provinceid].Rules.includes(permissiontag))
    },
    HasClubPermission: state => (clubid, permissiontag) => {
      return false || (permissiontag !== undefined && state.Clubs[clubid] && state.UserId > 0 && state.Clubs[clubid].Rules.includes(permissiontag))
    },
    Provinces: state => state.Provinces,
    Clubs: state => state.Clubs
  },
  mutations: {
    SecurityUpdated (state, payload) {
      state.UserId = payload.UserId
      state.Username = payload.Username
      state.Token = payload.Token
      state.Rules = payload.Rules
      state.Provinces = payload.Provinces
      state.Clubs = payload.Clubs
      state.Message = payload.Message
      state.LoggingIn = false

      if (payload.Token !== '') {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + payload.Token
      } else {
        axios.defaults.headers.common['Authorization'] = ''
      }
      if (payload && payload.UserId > 0) {
        document.documentElement.className = 'has-navbar-fixed-top'
      } else {
        document.documentElement.className = ''
      }
    }
  },
  actions: {
    Login (context, payload) {
      return new Promise((resolve, reject) => {
        if (this.state.security.UserId > 0) {
          resolve()
        }
        if (payload == null) {
          let token = Cookies.getRaw('va3')
          if (token == null || token === '') {
            context.commit('SecurityUpdated', {'UserId': '0', 'Username': ''})
            return
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          payload = {}
        }
        axios.post(context.rootState.vaconfig.ServerURL + 'security/login/', payload)
          .then((response) => {
            context.commit('SecurityUpdated', response.data)
            if (response.data.UserId && response.data.Token) {
              Cookies.setRaw('va3', response.data.Token)
              resolve()
            } else {
              Cookies.remove('va3')
              reject(new Error('login failed'))
            }
          }).catch(() => {
            reject(new Error('login error'))
          })
      })
    },
    Logout (context) {
      axios.post(context.rootState.vaconfig.ServerURL + 'security/logout/')
        .then((response) => {
          Cookies.remove('va3')
          context.commit('SecurityUpdated', response.data)
          context.commit('menu/ClearMenu', null, {root: true})
        }).catch((error) => {
          console.log(error)
        })
    }
  }
}

export default {
  security
}



// WEBPACK FOOTER //
// ./src/store/security.js